export type GenericColorPalette = {
    color1?: string
    color2?: string
    color3?: string

}

export const genericColorPaletteMap = new Map<string, GenericColorPalette>([
    ['yellow-white', {
        color1: "#f1b814",
        color2: "white",
    }],
    ['red-black', {
        color1: "#bd1e51",
        color2: "#490b3d",
    }],
    ['default', {
        color1: "#490b3d",
        color2: "#490b3d",
    }],
    ['red', {
        color1: "#ff0000",
        color2: "#b30000",
    }],
    ['green', {
        color1: "#00ff00",
        color2: "#008000",
    }],
    ['blue', {
        color1: "#0074d9",
        color2: "#001f3f",
    }],
    ['yellow', {
        color1: "#ffff00",
        color2: "#f1c40f",
    }],
    ['black', {
        color1: "#000000",
        color2: "#222222",
    }],
    ['white', {
        color1: "#ffffff",
        color2: "#f8f8f8",
    }],
    ['gray', {
        color1: "#808080",
        color2: "#d3d3d3",
    }],
])
